import { Header as FyndHeader } from '@goodfynd/layout';
import { useScreenMedium } from '@goodfynd/theme';

import config from '../../../config';
import { useApp, useAppDispatch } from '../../../context/AppContext';
import { DashboardUserProfile } from '../Sidebar/DashboardUserProfile';

import { MAIN_NAV } from './header-links';
import type { HeaderProps } from './types';

export default function Header({
  vendorNameId: profileNameId,
  ...props
}: Partial<HeaderProps>) {
  const { user, isLoggedIn } = useApp();
  const { logout } = useAppDispatch();
  const isMediumScreen = useScreenMedium();

  const navLinks =
    props.navLinks || MAIN_NAV({ user, profileNameId, isLoggedIn });

  return (
    <FyndHeader
      {...props}
      isAuthenticated={isLoggedIn}
      logoEnvironment={config.env.NAME_LOWER}
      logoType="vendors"
      navLinks={navLinks}
      theme="white"
      containerSx={{
        '&.MuiContainer-root': {
          maxWidth: '100%',
          padding: 'var(--Spacing-004) var(--Spacing-016)',
          width: 'calc(1440px - var(--sidebar-width))',

          '.img': {
            maxWidth: {
              xs: '192px',
              sm: '100%',
            },
            img: {
              maxWidth: '100%',
            },
          },
        },
      }}
      logout={() => {
        logout();
      }}
      userProfile={
        <DashboardUserProfile
          options={
            isMediumScreen
              ? [
                  ...navLinks,
                  {
                    divider: true,
                  },
                ]
              : []
          }
        />
      }
    />
  );
}
